export default {
    0: {
        type: 'Konservativ',
        goal:
            'Hohe Sicherheits- und Liquiditätsbedürfnisse mit nur geringer Renditeerwartung, Toleranz gegenüber geringen Kurs- bzw. Wertschwankungen',
    },
    1: {
        type: 'Risikoscheu',
        goal:
            'Sicherheitsberdürfnisse überwiegen Liquiditätsbedarf und Renditeerwartungen, Toleranz gegenüber geringen bis mäßigen Kurs- bzw. Wertschwankungen',
    },
    2: {
        type: 'Risikobereit',
        goal:
            'Sicherheit und Liquidität werden höherer Renditeerwarung untergeordnet, Toleranz gegenüber mäßigen bis teilweise starken Kurs- bzw. Wertschwankungen und Kapitalverlusten',
    },
    3: {
        type: 'Spekulativ',
        goal:
            'Streben nach kurzfristig hohen Renditechancen überwiegt Sicherheits- und Liquiditätsaspekte, Inkaufnahme von erheblichen Kurs- bzw. Wertschwankungen und Kapitalverlusten',
    },
    4: {
        type: 'Hochspekulativ',
        goal: 'Nutzung höchster Renditechancen bei hohem Risiko unter Inkaufnahme von Totalverlusten',
    },
};
